import { render, staticRenderFns } from "./PlayersAdmin.vue?vue&type=template&id=5736b616&scoped=true&"
import script from "./PlayersAdmin.vue?vue&type=script&lang=js&"
export * from "./PlayersAdmin.vue?vue&type=script&lang=js&"
import style0 from "./PlayersAdmin.vue?vue&type=style&index=0&id=5736b616&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5736b616",
  null
  
)

export default component.exports